import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';

const adminDocumentStatus = {
    id: 'admin-document-status',
    title: 'Geral',
    type: 'group',
    children: [
        {
            id: 'docs',
            title: 'Documentos',
            type: 'collapse',
            icon: FolderCopyOutlinedIcon,
            children: [
                {
                    id: 'docs-pendentes',
                    title: 'Pendentes',
                    type: 'item',
                    url: 'documentos-pendentes',
                    isChildren: true
                },
                {
                    id: 'docs-a-validar',
                    title: 'A validar',
                    type: 'item',
                    url: 'documentos-a-validar',
                    isChildren: true
                }
            ]
        }
    ]
};

export default adminDocumentStatus;
